import { useState } from 'react';
import { useRouter } from 'next/router';
import { deleteLine } from '~/services/queries/line';
import { DOWNLOAD_APP_LINK_LINE } from '@getin-widgets/shared/utils/constants';
import { Button } from '@getinapp/appetizer';
import { Share } from '@styled-icons/bootstrap/Share';
import { Toast } from '~/utils/toasts';

import KnifeIcon from '~/assets/images/knife-fork.svg';
import {
  GiveUpModal,
  Header,
  PositionBox,
  ResponsivenessWrapper,
} from '~/components';
import { Footer } from '@getin-widgets/ui';

import { LineWatchProps } from './types';
import * as S from './styles';
import { BannerList } from '~/components/BannerCarousel';

export const LineWatch = ({
  lineData,
  unitData,
  shared,
  banners,
  prediction,
  hasFooter,
  tolerance,
}: LineWatchProps) => {
  const router = useRouter();
  const [isGiveUpModalVisible, setIsGiveUpModalVisible] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);

  const handleGiveUp = () => setIsGiveUpModalVisible(true);

  const handleCancelLine = async () => {
    setLoadingCancel(true);
    const { status } = await deleteLine({ lineId: lineData.id });
    if (status === 204) router.push('/disabled-line');
    setLoadingCancel(false);
  };

  const handleClickCopy = () => {
    const hash = lineData.trackingUrl.split('/').pop();

    navigator.clipboard.writeText(
      `${lineData.trackingUrl.replace(hash as string, '')}!${hash}`
    );

    Toast('Link copiado com sucesso', 'info');
  };

  const handleSharePosition = async () => {
    try {
      await navigator.share({
        title: 'Compartilhar posição na fila',
        text: `Estou na posição ${lineData.position} da fila do ${unitData.name}!`,
        url: lineData.trackingUrl,
      });
    } catch (error) {
      handleClickCopy();
    }
  };

  return (
    <ResponsivenessWrapper>
      <>
        <GiveUpModal
          isModalVisible={isGiveUpModalVisible}
          setIsModalVisible={setIsGiveUpModalVisible}
          onCancelLine={handleCancelLine}
          loading={loadingCancel}
        />
        <S.InfoContent hasFooter={hasFooter}>
          <Header userName={lineData.name} />
          <PositionBox
            prediction={prediction}
            tolerance={tolerance}
            unitData={unitData}
            lineData={lineData}
          />

          {unitData.menu.show_in_line === 1 && unitData.menu.enabled === 1 && (
            <S.MenuButton>
              <a
                target="_blank"
                rel="noreferrer"
                href={`${process.env.NEXT_PUBLIC_GET_IN_MENU_URL}/pt-br/${unitData.id}`}
              >
                <S.WrapperContentMenuButton>
                  <img src={KnifeIcon.src} />
                  <S.WrapperTextMenuButton>
                    <span className="button-title">Veja o cardápio</span>
                    <span className="button-description">
                      Conheça os pratos e bebidas da casa
                    </span>
                  </S.WrapperTextMenuButton>
                </S.WrapperContentMenuButton>
              </a>
            </S.MenuButton>
          )}

          {banners.length > 0 && (
            <S.ContainerBannerList hasBanners={banners.length > 0}>
              <BannerList banners={banners} userId={lineData.id} />
            </S.ContainerBannerList>
          )}

          {!shared && (
            <S.ActionButtons>
              <Button>
                <S.ShareButtonContent onClick={handleSharePosition}>
                  <Share size={12} />
                  Compartilhar
                </S.ShareButtonContent>
              </Button>
              <Button onClick={handleGiveUp} variant="outline">
                Desistir da fila
              </Button>
            </S.ActionButtons>
          )}
        </S.InfoContent>
        {hasFooter && (
          <S.ContentFooter>
            <Footer linkDownload={DOWNLOAD_APP_LINK_LINE} />
          </S.ContentFooter>
        )}
      </>
    </ResponsivenessWrapper>
  );
};
